// Countup dei numeri (layout counter): da 0 al valore di data-stop quando entra in viewport.
// Il valore finale e' gia' nell'HTML: senza JS o con reduced motion resta quello.
document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".countup[data-stop]");

  if (!counters.length || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    return;
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // separatore migliaia "." come number_format del PHP (it-IT non separa i numeri a 4 cifre)
  const format = (value) => String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  counters.forEach((counter) => {
    const stop = parseFloat(counter.dataset.stop) || 0;
    const prefix = counter.dataset.prefix || "";
    const suffix = counter.dataset.suffix || "";
    const state = { value: 0 };
    const render = () => {
      counter.textContent = prefix + format(state.value) + suffix;
    };

    render();

    gsap.to(state, {
      value: stop,
      duration: 2,
      ease: "power2.out",
      onUpdate: render,
      scrollTrigger: {
        trigger: counter,
        start: "top 90%",
        once: true,
      },
    });
  });
});
